import { DomainStatusEnum, type DomainStatus } from '@flashpoint/site-dna';
import type { StepProps } from '../stepProps';
import { useLocalText } from '../useLocalText';

export function DomainStep({ lead, queueField }: StepProps) {
  const d = lead.domain;

  const [currentDomain, setCurrentDomain] = useLocalText(
    lead.id,
    d.currentDomain,
    'domain.currentDomain',
    queueField,
  );
  const [targetDomain, setTargetDomain] = useLocalText(
    lead.id,
    d.targetDomain,
    'domain.targetDomain',
    queueField,
  );

  return (
    <div className="space-y-5">
      <div>
        <div className="mb-2 text-[11px] uppercase tracking-widest text-nm-muted">Status</div>
        <div className="flex flex-col gap-2">
          {DomainStatusEnum.options.map((opt) => {
            const selected = d.status === opt;
            return (
              <button
                key={opt}
                type="button"
                onClick={() => queueField('domain.status', opt as DomainStatus)}
                className={`rounded-lg border p-3 text-left text-sm transition ${
                  selected
                    ? 'border-flashpoint-ember bg-nm-surface text-nm-ink'
                    : 'border-nm-border bg-nm-moss/30 text-nm-ink hover:border-nm-muted'
                }`}
              >
                {opt}
              </button>
            );
          })}
        </div>
      </div>

      {(d.status === 'Client Owns It' || d.status === 'Transferring Registrar' || d.status === 'Subdomain Of Existing') && (
        <label className="block">
          <span className="text-[11px] uppercase tracking-widest text-nm-muted">
            Current / existing domain
          </span>
          <input
            value={currentDomain}
            onChange={(e) => setCurrentDomain(e.target.value)}
            placeholder="example.com"
            className="mt-1 w-full rounded-md border border-nm-border bg-nm-bg px-3 py-2 text-sm text-nm-ink outline-none focus:border-nm-accent"
          />
        </label>
      )}

      {d.status !== 'Subdomain Of Existing' && (
        <label className="block">
          <span className="text-[11px] uppercase tracking-widest text-nm-muted">
            Target domain (final destination)
          </span>
          <input
            value={targetDomain}
            onChange={(e) => setTargetDomain(e.target.value)}
            placeholder="acmeplumbing.com"
            className="mt-1 w-full rounded-md border border-nm-border bg-nm-bg px-3 py-2 text-sm text-nm-ink outline-none focus:border-nm-accent"
          />
        </label>
      )}
    </div>
  );
}
